// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.ds.DataSourceBaseValue
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { DataSourceValue } from "abweb/dto/ds/DataSourceValue";
import { DataFieldTypeEnum } from "abweb/dto/generated/ds/DataFieldTypeEnum";
import { DataSourceSaveAction } from "abweb/dto/generated/ds/DataSourceSaveAction";
import { DataSourceState } from "abweb/dto/generated/ds/DataSourceState";
export class DataSourceBaseValueBase extends DataSourceValue {
  /** Do NOT invoke directly, instead use strongly typed createDataSourceBaseValueBase factory method */
  constructor() {
    super();
  }

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadd.DataSourceBaseValue";
  }
  initFromJson(json, deserializeContext) {
    this.initDataSourceBaseValue(json.attributeValues != null ? json.attributeValues : null, json.clientTag != null ? json.clientTag : null, json.dataSourceSaveAction != null ? DataSourceSaveAction.fromJson(json.dataSourceSaveAction) : null, json.editableOverwrite != null ? json.editableOverwrite : null, json.id != null ? json.id : null, json.state != null ? DataSourceState.fromJson(json.state) : null, json.baselineRefID != null ? json.baselineRefID : null, json.fieldTypeOverwrite != null ? DataFieldTypeEnum.fromJson(json.fieldTypeOverwrite) : null, json.refID != null ? json.refID : null);
  }
  initDataSourceBaseValue(attributeValues, clientTag, dataSourceSaveAction, editableOverwrite, id, state, baselineRefID, fieldTypeOverwrite, refID) {
    this.initDataSourceValue(attributeValues, clientTag, dataSourceSaveAction, editableOverwrite, id, state);
    this._baselineRefID = baselineRefID;
    this._fieldTypeOverwrite = fieldTypeOverwrite;
    this._refID = refID;
  }
  toTSOG(result, serializeContext) {
    const retVal = super.toTSOG(result, serializeContext);
    if (this._baselineRefID != null) {
      retVal["baselineRefID"] = this._baselineRefID;
    }
    if (this._fieldTypeOverwrite != null) {
      retVal["fieldTypeOverwrite"] = this._fieldTypeOverwrite;
    }
    if (this._refID != null) {
      retVal["refID"] = this._refID;
    }
    return retVal;
  }
  get baselineRefID() {
    return this._baselineRefID;
  }
  set baselineRefID(value) {
    this._baselineRefID = value;
  }
  get fieldTypeOverwrite() {
    return this._fieldTypeOverwrite;
  }
  set fieldTypeOverwrite(value) {
    this._fieldTypeOverwrite = value;
  }
  get refID() {
    return this._refID;
  }
  set refID(value) {
    this._refID = value;
  }
}
//# sourceMappingURL=DataSourceBaseValueBase.js.map
